/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReferralInvitationDto,
    ReferralInvitationDtoFromJSON,
    ReferralInvitationDtoFromJSONTyped,
    ReferralInvitationDtoToJSON,
} from './ReferralInvitationDto';

/**
 * 
 * @export
 * @interface ReferralInvitationsDto
 */
export interface ReferralInvitationsDto {
    /**
     * 
     * @type {number}
     * @memberof ReferralInvitationsDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralInvitationsDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralInvitationsDto
     */
    offset: number;
    /**
     * 
     * @type {Array<ReferralInvitationDto>}
     * @memberof ReferralInvitationsDto
     */
    items: Array<ReferralInvitationDto>;
}

export function ReferralInvitationsDtoFromJSON(json: any): ReferralInvitationsDto {
    return ReferralInvitationsDtoFromJSONTyped(json, false);
}

export function ReferralInvitationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralInvitationsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(ReferralInvitationDtoFromJSON)),
    };
}

export function ReferralInvitationsDtoToJSON(value?: ReferralInvitationsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(ReferralInvitationDtoToJSON)),
    };
}

